module.exports = __webpack_public_path__ + "f7d6c0d22926018306c2237aa46e9c66.svg";